// import { updatePlanModal, updatePlan, updatePlanPermissions } from 'store/user';
import React, { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ConfigProvider } from 'antd';
import RoutesConfig from 'routes';
import { AuthProvider } from 'context/AuthProvider';
import './App.scss';
import trackingService from 'services/trackingService';

// import PlanModal from 'components/PlanModal';
// import merchantAPI from 'services/merchants';
// import Alert from 'components/Alert';

function App() {
  const theme = useSelector((state) => state.user.theme);
  useEffect(() => {
    trackingService.initialize();
  }, []);
  // const isTrialUsed = useSelector((state) => state.user.plan.trial_used);

  // const dispatch = useDispatch();

  // const togglePlanModal = () => {
  //   dispatch(updatePlanModal(!planModal));
  // };

  // const activePlan = async (type, tenure, trial) => {
  //   const response = await merchantAPI.activatePlan({
  //     plan_type: type,
  //     tenure,
  //     trial
  //   });

  //   if (response.success) {
  //     dispatch(updatePlan(response.data));
  //     dispatch(updatePlanModal(!planModal));
  //     dispatch(updatePlanPermissions(response.data.permission_configs));
  //   } else {
  //     console.log('something went wrong');
  //     Alert('something went wrong', 'Please contact support team for this', 'error');
  //   }
  // };

  // useEffect(() => {
  //   // if (process.env?.REACT_APP_ENV === 'production') {
  //   trackingService.initializeTracking();

  //   // const GA_ID = process.env?.REACT_APP_GA_ID ?? '';
  //   // ReactGA.initialize([
  //   //   {
  //   //     trackingId: String(GA_ID)
  //   //   }
  //   // ]);
  //   // }
  // }, []);

  return (
    <AuthProvider>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: theme.colorPrimary,
            colorFillAlter: theme.colorFillAlter
          }
        }}
      >
        <style>
          {`
          :root {
            --color-primary: ${theme.colorPrimary};
            --color-fill-alter: ${theme.colorFillAlter};
          }
        `}
        </style>
        <RouterProvider router={RoutesConfig} />
        {/* {isTrialUsed !== undefined && (
          <PlanModal
            show={planModal}
            toggle={togglePlanModal}
            activePlan={activePlan}
            isTrialUsed={isTrialUsed}
          />
        )} */}
      </ConfigProvider>
    </AuthProvider>
  );
}

export default App;
